(function () {
	'use strict';

    /*
     CartController
    -------------------------------------------------------------------------- */

	angular
		.module('PublicApp.ShoppingCart.cart', [])
		.controller('CartController', [
			'$rootScope',
			'$scope',
			'appServices',
			'__DataStore',
			'__Form',
			'__Auth',
			'__Utils',
			'$compile',
			CartController
		]);

    /**
      * CartController handle add pages form
      *
      * @inject $rootScope
      * @inject $scope
      * @inject appServices
      * @inject __DataStore
      * @inject __Form
      * @inject 
      * 
      * @return void
      *-------------------------------------------------------- */

	function CartController($rootScope, $scope, appServices, __DataStore, __Form, __Auth, __Utils, $compile) {

		var scope = this;

		scope.userInfo = __Auth.authInfo();
		scope.isLoggedIn = __Auth.isLoggedIn();

		//authorized
		scope = __Form.setup(scope, 'update_cart_form', 'cartData', {
			modelUpdateWatcher: false
		});

		scope.cartDataStatus = false;

		// If user is not logged in then open logged in dialog
		scope.openLoginDialog = function () {
			var responseData = {
				'guestOrder': true
			};

			$rootScope.$broadcast('lw-open-login-dialog', { 'data': responseData });
		};

        /**
        * Open Discount details
        *
        * @return void
        *------------------------------------------------------------------------ */
		scope.openDiscountDetails = function () {
			$('#lw-discount-detail-table').slideToggle();
		}

		/**
	* Take cart content action action
	*
	* @return void
	*------------------------------------------------------------------------ */

		scope.cartData = {};
		scope.disabledStatus = false;
		scope.dataExistStatus = false;

		scope.getContentCart = function () {

			__DataStore
				.fetch('cart.get.data', { 'fresh': true })
				.success(
					function (responseData) {

						appServices.processResponse(
							responseData,
							null,
							function (reactionCode) {

								var requestData = responseData.data;
								scope.anyCartItemInvalid = requestData.isValidItem; // any cart item invalid
								scope.cartDiscount = requestData.orderDiscount;
								scope.cartTotalBeforeDiscount = requestData.cartTotalBeforeDiscount;
								scope.cartData.items = requestData.cartItems;
								scope.cartData.totalPrice = requestData.total;
								scope.cartItemStatus = requestData.cartItemStatus;
								scope.currentRoute = requestData.currentRoute;
								scope.isCurrencyMismatch = requestData.isCurrencyMismatch;
								scope = __Form.updateModel(scope, scope.cartData);


								if (scope.currentRoute == document.location.href) {
									var pageType = true;
								} else {
									var pageType = false;
								}

								if (!pageType) {
									_.defer(function () {
										var $discount = $compile(__Utils.template('#discountDetailsDialogTemplate', scope.cartDiscount))(scope);
										scope.discountDetailsHtml = $discount.html();
									});
								} else {
									var $discount = $compile(__Utils.template('#discountDetailsDialogTemplate', scope.cartDiscount))(scope);
									scope.discountDetailsHtml = $discount.html();
								}

								scope.pageType = pageType;

								scope.data = {
									'routeStatus': pageType
								}

								if (_.isEmpty(requestData.cartItems) || requestData.isValidItem == false) {
									scope.disabledStatus = false;
								} else {
									scope.disabledStatus = true;
								}

								scope.cartDataStatus = true;
								$scope.$emit('lw.current.route.name', scope.data);
							});
					});
		};
		scope.getContentCart();

        /**
        * Refresh product 
        *
        * @return void
        * 
        *------------------------------------------------------------------------ */
		scope.refreshProduct = function (item) {
			__DataStore.post('cart.refresh.product', item)
				.success(function (responseData) {
					appServices.processResponse(responseData, null, function () {
						scope.getContentCart();
					});
				});
		};

	    /**
	    * update product cart quantity in cart
	    *
	    * @return void
	    * 
	    *------------------------------------------------------------------------ */
		var timer;
		scope.updateQuantity = function (status, rowID, qty, newPrice) {
			// filter quantity
			var filterQty = Number(Math.round(qty));
			scope.cartData.items[rowID].qtyStatus = false;
			scope.cartQuantity = filterQty;

			if (status == 'eventUp') {


				if (filterQty > 1) {

					if (filterQty > 99999) {
						scope.cartData.items[rowID].qty = filterQty;
					};

				} else {

					scope.cartData.items[rowID].qty = 1;
					scope.cartData.items[rowID].qtyStatus = true;
				}

			} else {

				if (status == true) {
					scope.cartData.items[rowID].qty = filterQty + 1;
				} else {
					var newValue = (filterQty - 1);
					(newValue <= 0)
						? scope.cartData.items[rowID].qty = 1
						: scope.cartData.items[rowID].qty = newValue;
				}

			}

			if (rowID) {
				// clear time
				window.clearTimeout(timer);

				// in cart table change quantity fire request per 3 sec
				timer = window.setTimeout(function () {

					__Form.process({
						'apiURL': 'cart.update.qty',
						'itemID': rowID
					}, scope)
						.success(function (responseData) {

							appServices.processResponse(
								responseData,
								null,
								function () {

									var requestData = responseData.data;

									scope.cartDiscount = requestData.orderDiscount;
									scope.cartTotalBeforeDiscount = requestData.cartTotalBeforeDiscount;
									if (!scope.pageType) {
										_.defer(function () {
											var $discount = $compile(__Utils.template('#discountDetailsDialogTemplate', scope.cartDiscount))(scope);
											scope.discountDetailsHtml = $discount.html();
										});
									} else {
										var $discount = $compile(__Utils.template('#discountDetailsDialogTemplate', scope.cartDiscount))(scope);
										scope.discountDetailsHtml = $discount.html();
									}

									// for new price scope
									scope.cartData.items[rowID].new_price = requestData.new_price;
									scope.cartData.items[rowID].new_subTotal = requestData.new_subTotal;
									scope.cartData.items[rowID].qty = requestData.qty;
									scope.cartData.items[rowID].price = requestData.price;
									scope.cartData.totalPrice = requestData.total;
									scope.cartData.items[rowID].qtyStatus = true;

									scope.data = {
										'cart_string': requestData.cartItems,
										'status': true
									}
									scope.qtyStatus = true;
									// scope.getContentCart();
									$scope.$emit('lw.update.cart.string', scope.data);
									$rootScope.$emit('remove.cart.row', { 'status': true });

									$scope.$emit('lw.cart_update', {
										'qty': requestData.qty,
										'pid': scope.cartData.items[rowID].id,
										'action': 1
									});
								}
							);
						});

				}, 500);
			}
		};

	    /**
	  	  * Close dialog and return promise object
	  	  *
	  	  * @return void
	  	  *---------------------------------------------------------------- */

		scope.cancel = function () {
			$scope.closeThisDialog();
		};

		/**
	  * remove cart item action
	  *
	  * @return void
	  *---------------------------------------------------------------- */
		scope.removeCartItem = function (itemID) {

			// get data using angular $http.get() method
			__DataStore.post({
				'apiURL': 'cart.remove.item',
				'itemID': itemID
			}, scope).success(function (responseData) {

				appServices.processResponse(responseData, null,
					function (reactionCode) {

						$scope.$emit('lw.cart_update', {
							'qty': 0,
							'pid': scope.cartData.items[itemID].id,
							'action': 2
						});

						$rootScope.$emit('changeItems', {
							status: true
						});

						scope.data = {
							'cart_string': responseData.data.cartItems,
							'status': true
						}

						$scope.$emit('lw.update.cart.string', scope.data);

						$('#rowid_' + itemID).fadeOut('slow', function () {
							//$(this).remove();
						});

						scope.getContentCart();
					}
				);

			});
		};

		/**
* remove all items from cart item action
*
* @return void
*------------------------------------------------------------------------ */
		scope.removeAllItemsItem = function () {

			var removedPIds = [];

			if (!_.isEmpty()) {

				_.each(scope.cartData.items, function (value, key) {
					removedPIds.push(value);
				});
			}

			// get data using angular $http.get() method
			__DataStore.post('cart.remove.all.items', scope).success(function (responseData) {

				appServices.processResponse(responseData, null,
					function (reactionCode) {

						$scope.$emit('lw.cart_update', {
							'action': 3, 'removedPIds': removedPIds
						});

						scope.cartData.items = '';

						scope.data = {
							'cart_string': responseData.data.cartItems,
							'status': true
						}

						$scope.$emit('lw.update.cart.string', scope.data);

						$rootScope.$emit('remove.cart.row', { 'status': true });

						$rootScope.$emit('changeItems', {
							status: true
						});

						scope.getContentCart();
					}
				);

			});

		};

	};

})();